//import { useState } from "react";
import Hero from './Hero';
import About from './About';
import Pricing from './Pricing';
import Location from './Location';
import FAQ from './FAQ';
import Coach from './Coach';
import Footer from './Footer';
import ReviewSection from './ReviewSection';
import AnnouncementModal from "./AnnouncementModal";
import BlogList from './Blog';

function App() {
  //const [user, setUser] = useState(null);
  return (
    <div className="bg-gray-100">
      <Hero />
      <AnnouncementModal />
      <BlogList/>
      <ReviewSection/>
      <About />
      <Pricing />
      <Location />
      <Coach />
      <FAQ />
      <Footer />
      {/* Add more sections like Pricing, Contact, Footer here */}
    </div>
  );
}

export default App;
